module.exports = __webpack_public_path__ + "img/tf.fd20c9ec.svg";